import { FiCalendar, FiUsers } from 'react-icons/fi'
import { MenuItem } from '../types'

const settingsMenu: MenuItem[] = [
  {
    icon: FiUsers,
    name: 'Users',
    path: '/settings/users',
    code: 'settings',
  },
  {
    icon: FiCalendar,
    name: 'Events',
    path: '/settings/events',
    code: 'settings',
  },
]

export default settingsMenu
